import React, { useEffect } from 'react';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import { LimitReached } from '../WelcomeScreen';
import CNIntroScreen from '../CNIntroScreen';
import {
  CN_OPT_IN_LIMIT,
  hasProgramsOrReports,
  type PartnerLoginData,
  TODO_URL,
} from '../utils';

const onContinue = () => {
  window.location.href = TODO_URL;
};

export default function CnTaskUpdates({ loginData }: { loginData: PartnerLoginData }) {
  const limitReached = (loginData.cn_opted_in_count ?? 0) >= CN_OPT_IN_LIMIT;

  // Returning users who already have a program or report skip the intro and go
  // straight to their to-do page.
  const skipIntro = !limitReached && hasProgramsOrReports(loginData);

  useEffect(() => {
    if (skipIntro) onContinue();
  }, [skipIntro]);

  if (limitReached) {
    return <LimitReached />;
  }

  if (skipIntro) {
    return (
      <div className="cn-loading-container">
        <TrueImpactLoading />
      </div>
    );
  }

  return <CNIntroScreen onContinue={onContinue} />;
}
